// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"dd605ee4","98":"fd04029d","372":"6270d7c1","384":"cbaa7f98","453":"b8126854","634":"34a329b8","728":"5143e824","754":"ef631168","981":"5bfff41c"}[chunkId] + ".chunk.js";
};